import { Star, ShoppingCart, ClipboardList } from 'lucide-react'

function PriceTag({ product, segment }) {
  if (segment === 'retail') {
    return (
      <div className="text-lg font-bold text-brand-navy">
        €{product.price.toFixed(2)}
        <span className="ml-1 text-xs font-normal text-brand-slate">/ unit</span>
      </div>
    )
  }

  const starting = product.pricing?.[0]?.price ?? 0
  const unit = product.moqUnit || 'units'
  return (
    <div className="text-sm text-brand-ink">
      <span className="text-lg font-bold text-brand-navy">€{starting.toFixed(2)}</span>
      <span className="ml-1 text-brand-slate">/ {unit}</span>
      <div className="mt-0.5 text-xs text-brand-slate">
        MOQ {product.moq} {unit}
      </div>
    </div>
  )
}

export function ProductCard({ product, segment, onSelect, onAdd }) {
  const isRetail = segment === 'retail'

  return (
    <div
      onClick={() => onSelect(product)}
      className="group card-lift flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-brand-slate/10 bg-white shadow-card hover:border-brand-gold/30"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-brand-shell">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute left-3 top-3 rounded-md bg-brand-navy/85 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white shadow-sm backdrop-blur-sm">
          {product.category}
        </div>
        <div className="absolute inset-x-0 bottom-0 h-1 bg-brand-gold transform scale-x-0 transition-transform duration-300 group-hover:scale-x-100" />
      </div>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-semibold leading-tight text-brand-ink transition-colors group-hover:text-brand-ocean">
          {product.name}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-snug text-brand-slate">
          {product.description}
        </p>

        {isRetail && product.rating && (
          <div className="mt-2 flex items-center gap-1 text-xs text-brand-slate">
            <Star className="h-3.5 w-3.5 fill-brand-gold text-brand-gold" />
            <span className="font-medium text-brand-ink">{product.rating}</span>
            <span>({Math.floor(Math.random() * 80) + 20} reviews)</span>
          </div>
        )}

        <div className="mt-4 flex items-end justify-between gap-2">
          <PriceTag product={product} segment={segment} />
          <button
            onClick={(e) => {
              e.stopPropagation()
              onAdd(product)
            }}
            className="flex shrink-0 items-center gap-1.5 rounded-lg bg-brand-navy px-3 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-ocean"
          >
            {isRetail ? (
              <>
                <ShoppingCart className="h-4 w-4" />
                <span className="hidden sm:inline">Add</span>
                <span className="sm:hidden">+</span>
              </>
            ) : (
              <>
                <ClipboardList className="h-4 w-4" />
                <span className="hidden sm:inline">Quote</span>
                <span className="sm:hidden">+</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
